import React from "react";
import { styled } from "@linaria/react";
import { color } from "@ui";
import classNames from "classnames";
import { THREAD_CN, THREAD_SELECTED_CN } from "./MessageCard";
import type { ActiveAnalysis } from "../../../api/useActiveAnalysesStream";

interface P {
  children: React.ReactNode;
  selected: boolean;
  setHoveredAnalysisId: React.Dispatch<React.SetStateAction<string | null>>;
  setAnalysis: (date: number | null) => void;
  analyses: ActiveAnalysis[];
  setSelectedCommentId: React.Dispatch<React.SetStateAction<string | undefined>>;
  analysisId: string | null;
  id: string;
}

const Wrapper = styled.div`
  :hover {
    background-color: ${color.titanium50};
    box-shadow: inset 0.1em 0em ${color.titanium200};
  }

  :focus-within,
  &.${THREAD_SELECTED_CN} {
    background-color: ${color.lightNitrogen50};
    box-shadow: inset 0.1em 0em ${color.lightNitrogen500_Main};
  }
`;

const CommentThread = ({
  children,
  selected,
  setHoveredAnalysisId,
  setAnalysis,
  analyses,
  setSelectedCommentId,
  analysisId,
  id,
}: P) => (
  <Wrapper
    className={classNames(THREAD_CN, {
      [THREAD_SELECTED_CN]: selected,
    })}
    onMouseEnter={() => {
      setHoveredAnalysisId(analysisId ?? null);
    }}
    onMouseLeave={() => setHoveredAnalysisId(null)}
    onClick={() => {
      const analysis = analyses.find(analysis => analysis.id === analysisId);
      setSelectedCommentId(id);
      if (analysis !== undefined) setAnalysis(analysis.date);
    }}
  >
    {children}
  </Wrapper>
);

export default React.memo(CommentThread);
